import MasterCrudPage from "../../components/MasterCrudPage";
import {
  cartApi,
  serviceApi,
  userMasterApi,
} from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

export default function Cart() {
  return (
    <MasterCrudPage
      title="Cart"
      description="Manage user cart items linked to assets."
      idKey="cart_id"
      api={cartApi}
      listLabel="cart items"
      useJson
      loadExtraOptions={async () => {
        const [users, assets] = await Promise.all([
          userMasterApi.list(),
          serviceApi.list(),
        ]);

        return {
          users: (users || []).map((user) => ({
            value: user.user_id,
            label: userLabel(user),
          })),
          assets: (assets || []).map((asset) => ({
            value: asset.service_id,
            label: asset.service_title || "Asset",
          })),
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User",
          type: "select",
          required: true,
          optionsKey: "users",
          placeholder: "Select user",
        },
        {
          name: "asset_id",
          label: "Asset",
          type: "select",
          required: true,
          optionsKey: "assets",
          placeholder: "Select asset",
        },
        {
          name: "quantity",
          label: "Quantity",
          type: "number",
          required: true,
          min: "1",
          step: "1",
          defaultValue: 1,
          placeholder: "1",
        },
      ]}
      columns={[
        { key: "cart_id", label: "Cart ID" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        {
          key: "asset_id",
          label: "Asset",
          render: (item) => item.service_title || "—",
        },
        { key: "quantity", label: "Quantity" },
        {
          key: "added_at",
          label: "Added Date",
          render: (item) =>
            item.added_at
              ? String(item.added_at).replace("T", " ").slice(0, 19)
              : "—",
        },
      ]}
    />
  );
}
